import api from './api';

export class CouponService {
  // #512: com `planId` o servidor recusa o cupom que não aceita o tipo do
  // plano; a resposta traz `allowed_payment_method` pro preço por forma.
  static async validate(code: string, planId?: string) {
    console.log('🌐 Enviando requisição para validar cupom:', { code, planId });

    const response = await api.post('/coupons/validate', planId ? { code, planId } : { code });

    console.log('🌐 Resposta da validação:', {
      status: response.status,
      data: response.data,
    });

    return response.data.data;
  }
}
